import { useQuery, useMutation } from "react-query";
import { message } from "antd";
import { useTranslation } from "react-i18next";

import * as api from "apis/bankAccount";

//Query untuk get all bank accounts
export function useBankAccounts(options = {}) {
  const { t } = useTranslation();
  return useQuery(
    ["bankAccounts"],
    async () => {
      let response = {};
      try {
        const {
          data: { data },
        } = await api.getBankAccounts();
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

// Query untuk add bank account
export const useAddBankAccount = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.addBankAccount(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk edit bank account
export const useEditBankAccount = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.editBankAccount(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

// Query untuk delete bank account
export const useDeleteBankAccount = () => {
  const { t } = useTranslation();
  return useMutation((id) => api.deleteBankAccount(id), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};
